{
  "404": {
    "description": "Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.",
    "go_to_home": "Go To Home",
    "ops_nothing_to_see_here": "Ops, there's nothing to see here",
    "title": "404 Page Not Found"
  },
  "actors": {
    "actor_view": {
      "actor_updated_successfully": "Actor successfully updated!",
      "page_title": "Actor",
      "sections": { "company_data": "Company Data", "notification_groups": "Notification Groups" }
    },
    "actors_list": {
      "actor_deleted": "Actor successfully deleted!",
      "add_new_actor": "Add Actor",
      "page_title": "Actors"
    },
    "new_actor": { "page_title": "Register Actor", "success": "Actor successfully added." }
  },
  "agents": {
    "all_agents": "All Agents",
    "btn_create": "Create Agent",
    "create_success": "Agent successfully created!",
    "executions": {
      "cards": { "total": "Total executions", "errors": "Failed", "today": "today" },
      "new": "New Agent",
      "page_title": "Agents Executions",
      "status": { "failed": "Failed", "all": "All" },
      "table": { "duration": "Duration", "entity_type": "Entity Type", "scheduled": "Scheduled" },
      "tabs": { "production": "Production", "test_runs": "Test Runs" },
      "test_run": "Test Run",
      "detail": {
        "action": "Action",
        "callback_curl": "Or fire the callback yourself — your service should POST something equivalent to this.",
        "callback_url": "Callback URL (POST result here)",
        "dispatch": { "waiting_callback": "Waiting for callback" },
        "entity_data": "Entity Data",
        "insights_successful": "{{count}} insights inserted/updated",
        "orders_successful": "{{count}} orders inserted/updated",
        "output": "Output",
        "processes_successful": "{{count}} processes inserted/updated",
        "processes_tracked_successful": "{{count}} processes updated",
        "processing": "Processing",
        "started_at": "Started at",
        "step_not_started": "This step has not been executed yet.",
        "steps": "Steps",
        "trigger": "Trigger",
        "triggered_at": "Triggered at",
        "webhook_response": "Webhook response",
        "manual_curl": {
          "label": "Manual cURL — run this on your machine",
          "description": "The execution waits for a callback. Paste the cURL below into your terminal — it already includes the processor URL configured on the agent. You can change it to call another endpoint, including local. Your service runs and POSTs to the callback URL below — no tunnel needed."
        },
        "status": {
          "failed": "failed",
          "pending": "pending",
          "running": "running",
          "skipped": "skipped",
          "success": "success"
        }
      },
      "dev_mode_modal": {
        "dispatch_hint": "Flowls POSTs the input to the agent’s configured URL.",
        "execute_actions_hint": "Actions execute as in production — DB writes will happen.",
        "execute_actions": "Execute actions",
        "invalid_json": "Invalid JSON. Please fix the JSON to run the test.",
        "manual_curl_hint": "No outbound POST. Flowls generates a cURL you run locally — no tunnel needed.",
        "run_test": "Run Test",
        "select_lpco_input": "Pick a Lpco",
        "select_order_input": "Pick a Order",
        "select_process_input": "Pick a Process",
        "skip_actions_hint": "Validate the callback shape but do NOT write to the database.",
        "skip_actions": "Skip actions (default)",
        "title": "Compose test run",
        "input_label": "Input"
      }
    },
    "form": {
      "step_name": {
        "subtitle": "Give this agent a clear name to make it easy to identify.",
        "title": "Name your agent"
      },
      "step_trigger": {
        "subtitle": "Define what starts this agent.",
        "title": "Choose a Trigger",
        "descriptions": {
          "event_trigger": "Fire when a specific event occurs on a record",
          "received_mail": "Fire when an email arrives in the inbox",
          "received_teams_message": "Fire from a channel or DM in Teams",
          "recurring_schedule": "Run on a fixed interval (daily, weekly, etc.)",
          "webhook": "Receive a POST from an external system"
        },
        "event_trigger_form": { "entity": "Entity", "entity_subtitle": "Select the type of record to monitor." },
        "recurring_schedule_form": {
          "frequency_periods": { "DAYS": "days", "HOURS": "hours", "WEEKS": "weeks" },
          "frequency": "Frequency",
          "recurring_schedule": "Run every"
        },
        "webhook": {
          "info": "The URL and API Key for the inbound webhook will be generated after the agent is created."
        }
      },
      "step_configure_input": {
        "subtitle": "Define where the data for this agent comes from.",
        "title": "Configure the Input",
        "descriptions": {
          "external_api": "Call a REST API to fetch data",
          "google_drive": "Read data from a Google Sheets spreadsheet",
          "no_input": "Run the agent without any input",
          "operations": "Select operations, entity and filters",
          "sharepoint": "Fetch data from a SharePoint list"
        },
        "operations_form": {
          "filters": "Process only records that meet these conditions.",
          "operation_description": "Select which operations this schedule runs."
        }
      },
      "step_processor": {
        "configure_title": "Configure: {{ processor }}",
        "subtitle": "Select the logical step that analyzes or transforms the input.",
        "title": "Choose a Processor",
        "form": {
          "custom_webhook": {
            "auth_type": "Authentication",
            "credential": "Authentication credential",
            "disclaimer": "This processor sends the agent's payload to its endpoint, which can transform the data before the selected actions are executed.",
            "expected_keys": "Expected keys in the response: `orders`, `processes`.",
            "headers": { "key": "Key", "value": "Value" }
          }
        }
      },
      "step_actions": {
        "default": "Default",
        "disclaimer": "Actions will be executed in sequence automatically.",
        "subtitle": "A default action is included automatically. You can optionally add more.",
        "title": "Actions",
        "descriptions": {
          "post_in_teams": "Post a message to a Microsoft Teams channel",
          "send_email": "Send an email to a recipient or responsible role",
          "set_insights": "Save inconsistency findings",
          "update_tracking": "Update process tracking data from the received data",
          "upload_document": "Create a document for a specific entity",
          "upsert_orders": "Create or update orders from the received data",
          "upsert_processes": "Create or update processes from the received data",
          "upsert_products": "Create or update products from the received data"
        },
        "infos": {
          "update_tracking": "This action consumes <b>processes</b>.",
          "upsert_orders": "This action consumes <b>orders</b>.",
          "upsert_processes": "This action consumes <b>processes</b>.",
          "upsert_products": "This action consumes <b>products</b>."
        }
      }
    },
    "list": { "page_title": "Configured Agents", "new": "New Agent" }
  },
  "attendance_phase": { "subsidiary": { "title": "Carrier" } },
  "audit_checklist": {
    "approve_audit": "Approve Audit",
    "do_you_want_to_audit_order": "Do you want to approve the audit?",
    "title": "Checklist"
  },
  "automations": {
    "creation": {
      "fields_for_categories": {
        "1": { "args": { "1": { "title": "When have passed" } } },
        "2": { "args": { "1": { "title": "When have passed" }, "2": { "title": "Without confirmation of" } } },
        "3": { "args": { "1": { "title": "When left" } } },
        "4": { "args": { "1": { "title": "When left" }, "2": { "title": "Without confirmation of" } } },
        "5": { "args": { "1": { "title": "When arrives" } } },
        "6": { "args": { "1": { "title": "When arrives" }, "2": { "title": "Without confirmation of" } } },
        "7": { "args": { "1": { "title": "When" }, "2": { "title": "is later than" }, "3": { "title": "by" } } }
      },
      "form": {
        "date_field": { "in": "from" },
        "field": "Field",
        "filters": "For the conditions:",
        "quantity": "Qty.",
        "success": "Automation successfully created!",
        "webhook": "Provide URL"
      },
      "templates": { "label": "Date Templates" },
      "title": "Create Automation"
    },
    "delete": { "success": "Automation successfully deleted!", "title": "Delete {{title}}?" },
    "list": {
      "descriptions": {
        "AFTER_DATE": "When have passed <b>{{amount}}</b> <b>{{type}}</b> from <b>{{date}}</b>",
        "AFTER_DATE_WITH_FIELD": "When have passed <b>{{amount}}</b> <b>{{type}}</b> from <b>{{date}}</b> without confirmation of <b>{{confirmation}}</b>",
        "BEFORE_DATE": "When there are <b>{{amount}}</b> <b>{{type}}</b> left until <b>{{date}}</b>",
        "BEFORE_DATE_WITH_FIELD": "When there are <b>{{amount}}</b> <b>{{type}}</b> left until <b>{{date}}</b> without confirmation of <b>{{confirmation}}</b>",
        "ON_DATE": "When arrives <b>{{date}}</b>",
        "ON_DATE_WITH_FIELD": "When arrives <b>{{date}}</b> without confirmation of <b>{{confirmation}}</b>",
        "ON_DATE_GREATER_THAN": "When <b>{{date}}</b> is later than <b>{{dateTarget}}</b> by <b>{{amount}}</b> <b>{{type}}</b>"
      },
      "periods": {
        "DAYS": "days",
        "DAYS_one": "day",
        "HOURS": "hours",
        "HOURS_one": "hour",
        "MINUTES": "minutes",
        "MINUTES_one": "minute",
        "MONTHS": "months",
        "MONTHS_one": "month"
      },
      "title_one": "{{count}} automations in <b>{{operationName}}</b>",
      "title_other": "{{count}} automations in <b>{{operationName}}</b>"
    },
    "periods": { "DAYS": "Days", "HOURS": "Hours", "MINUTES": "Minutes", "MONTHS": "Months" },
    "status": { "off": "OFF", "on": "ON" },
    "templates": {
      "AFTER_DATE": "When has passed <b>a period</b> from <b>a date</b>",
      "AFTER_DATE_WITH_FIELD": "When has passed <b>a period</b> from <b>a date</b> without <b>a field confirmation</b>",
      "BEFORE_DATE": "When there are <b>a period</b> left until <b>a date</b>",
      "BEFORE_DATE_WITH_FIELD": "When there are <b>a period</b> left until <b>a date</b> without <b>a field confirmation</b>",
      "ON_DATE": "When arrives <b>a date</b>",
      "ON_DATE_WITH_FIELD": "When arrives <b>a date</b> without <b>a field confirmation</b>",
      "ON_DATE_GREATER_THAN": "When <b>a date</b> is later than <b>another date</b> by <b>a period</b>"
    }
  },
  "buttons": {
    "add": "Add",
    "active": "Activate",
    "archive": "Archive",
    "back": "Back",
    "cancel": "Cancel",
    "close": "Close",
    "clear_all": "Clear all",
    "confirm": "Confirm",
    "delete": "Delete",
    "download": "Download",
    "edit": "Edit",
    "filters": "Filters",
    "process_filters": "Process",
    "lead_time_filters": "Lead Time",
    "go_to_home": "Back Home",
    "hide": "Hide",
    "hide_all": "Hide all",
    "inactive": "Disable",
    "keep_editing": "Keep Editing",
    "not_save": "Don't Save",
    "register": "Register",
    "remove": "Remove",
    "save": "Save",
    "save_changes": "Save Changes",
    "show": "Show",
    "show_all": "Show All",
    "undo_cancel": "Undo Cancellation",
    "undo_delete": "Undo Deletion",
    "view": "View",
    "yes_delete": "Yes, Delete"
  },
  "common": {
    "cellphone": "Phone",
    "copied": "Copied",
    "copy": "Copy",
    "hours": "Hours",
    "plate": "Plate",
    "type": "Type"
  },
  "datagrid": {
    "actionsCellMore": "more",
    "checkboxSelectionHeaderName": "Select Checkbox",
    "columnHeaderFiltersLabel": "Show Filters",
    "columnHeaderSortIconLabel": "Sort",
    "columnMenuFilter": "Filters",
    "columnMenuHideColumn": "Hide",
    "columnMenuLabel": "Menu",
    "columnMenuManageColumns": "Manage Columns",
    "columnMenuShowColumns": "Show Columns",
    "columnMenuSortAsc": "Sort Ascending",
    "columnMenuSortDesc": "Sort Descending",
    "columnMenuUnsort": "Don't Sort",
    "sortByTitle": "Sort by",
    "sortDirectionTitle": "Direction",
    "sortDirectionDesc": "Descending",
    "sortDirectionAsc": "Ascending",
    "columnsManagementSearchTitle": "Find Column",
    "columnsManagementShowHideAllText": "Show/Hide All",
    "columnsManagementNoColumns": "No columns",
    "columnsManagementReset": "Reset",
    "filterOperatorAfter": "after",
    "filterOperatorBefore": "before",
    "filterOperatorContains": "contains",
    "filterOperatorEndsWith": "ends with",
    "filterOperatorEquals": "equal",
    "filterOperatorIs": "is",
    "filterOperatorIsAnyOf": "is any of",
    "filterOperatorIsEmpty": "is empty",
    "filterOperatorIsNotEmpty": "not empty",
    "filterOperatorNot": "is not",
    "filterOperatorNotContains": "not contains",
    "filterOperatorNotEquals": "not equals",
    "filterOperatorIsNoneOf": "is none of",
    "filterOperatorOnOrAfter": "on or after",
    "filterOperatorOnOrBefore": "on or before",
    "filterOperatorStartsWith": "starts with",
    "filterPanelAddFilter": "Add Filter",
    "filterPanelColumns": "Columns",
    "filterPanelDeleteIconLabel": "Remove",
    "filterPanelInputLabel": "Value",
    "filterPanelInputPlaceholder": "Filter Value",
    "filterPanelOperator": "Operators",
    "filterPanelOperatorAnd": "AND",
    "filterPanelOperatorOr": "OR",
    "filterPanelRemoveAll": "Clear Filters",
    "filterValueAny": "Any",
    "filterValueFalse": "No",
    "filterValueTrue": "Yes",
    "footerRowSelectedMore": "{{count}} selected rows",
    "footerRowSelectedOne": "1 selected row",
    "footerTotalRows": "Total",
    "footerTotalVisibleRows": "{{visibleCount}} of {{totalCount}}",
    "labelDisplayedRows": "{{from}} - {{to}} of {{count}}",
    "labelDisplayedRowsUnknown": "{{from}} - {{to}}",
    "labelRowsPerPage": "Rows per page",
    "noResultsOverlayLabel": "No results found",
    "noRowsLabel": "No results",
    "pinToLeft": "Pin to the left",
    "pinToRight": "Pin to the right",
    "toolbarColumns": "Columns",
    "toolbarColumnsLabel": "Select columns",
    "toolbarDensity": "Density",
    "toolbarDensityComfortable": "Confortable",
    "toolbarDensityCompact": "Compact",
    "toolbarDensityStandard": "Standard",
    "toolbarExport": "Export",
    "toolbarExportCSV": "Download CSV",
    "toolbarFilters": "Filters",
    "toolbarFiltersLabel": "Show Filters",
    "toolbarFiltersTooltipActiveMore": "{{count}} active filters",
    "toolbarFiltersTooltipActiveOne": "1 active filter",
    "toolbarFiltersTooltipHide": "Hide Filters",
    "unpin": "Unpin"
  },
  "datepickers": {
    "range_shortcuts": {
      "this_week": "This Week",
      "last_week": "Last Week",
      "last_7_days": "Last 7 Days",
      "last_30_days": "Last 30 Days",
      "current_month": "Current Month",
      "last_month": "Last Month",
      "reset": "Reset"
    }
  },
  "drivers": {
    "drivers_list": {
      "add_new_driver": "Add Driver",
      "driver_deleted": "Driver successfully deleted!",
      "page_title": "Drivers",
      "title": "Drivers"
    },
    "drivers_new": { "page_title": "Add Driver", "success": "Driver successfully added!", "title": "Register Driver" },
    "edit_driver": { "page_title": "Edit Driver", "success": "Driver successfully updated", "title": "Edit Driver" }
  },
  "entities_report": {
    "actor": "Actors",
    "driver": "Drivers",
    "mercante": "Mercante",
    "product": "Products",
    "route": "Routes",
    "trailer": "Trailers",
    "vehicle": "Vehicles"
  },
  "errors": { "something_went_wrong": "Something went wrong!" },
  "external_invite": {
    "attachments": {
      "count_one": "{{count}} file",
      "count_other": "{{count}} files",
      "dropzone_title_one": "Drag the file or click to upload",
      "dropzone_title_other": "Drag files or click to attach",
      "file_invalid_type": "{{name}}: file type not accepted",
      "file_too_large": "{{name}}: exceeds 10 MB",
      "optional": "— optional",
      "select_files_one": "Select file",
      "select_files_other": "Select files"
    },
    "booking_data": {
      "booking_number": "Booking number",
      "closed_description": "The ATD has been recorded and this page is read-only.",
      "confirm_description": "Review the data before sending. Sending updates the process and replaces the current values.",
      "copy_to": "A summary will be sent to {{email}}.",
      "document": "Booking document (PDF)",
      "document_caption": "PDF only, up to 10 MB",
      "editable_until_atd": "You can correct and resend until the ATD.",
      "eta_before_etd": "The ETA cannot be earlier than the ETD.",
      "form_hint": "Enter the number, the document and the routing confirmed with the carrier.",
      "load_error": "The shipment data could not be loaded. Reload the page.",
      "review": "Review",
      "send": "Send booking",
      "sent": "Booking sent.",
      "winner_proposal": "winning proposal {{number}}. Fill in the booking data below."
    },
    "booking_quotation": {
      "all_proposals": "All submitted proposals",
      "closed_description": "Closed on {{date}}. These are the submitted proposals.",
      "completed_description": "The winning agent has been selected. Thank you for participating.",
      "confirm_edit_description": "Review the changes before saving. The proposal can be edited until the closing.",
      "confirm_send_description": "Review the summary before sending. The proposal can be edited until the closing.",
      "copy_to": "A copy will be sent to {{email}}.",
      "days_one": "{{count}} day",
      "days_other": "{{count}} days",
      "decline": "I won't participate",
      "decline_confirm": "Decline participation",
      "decline_confirm_description": "You will stop participating in this quotation and won't be able to submit proposals. If you'd like, tell the shipper why.",
      "decline_confirm_title": "I won't participate",
      "decline_reason_hint": "Notes are visible only to the shipper.",
      "decline_reason_label": "Reason (optional)",
      "declined_description": "You said you won't participate in this quotation. Thank you for letting us know.",
      "declined_title": "Participation declined",
      "dropzone_caption": "PDF, XLSX, DOCX or image · up to 10 MB each · multiple files",
      "edit": "Edit proposal {{sequence}}",
      "editable_until_close": "Editable until the quotation closes.",
      "editing": "Editing",
      "empty_proposals": "You did not submit proposals for this quotation.",
      "international": "International",
      "international_transport": "International transport",
      "load_error": "The quotation could not be loaded. Reload the page.",
      "new_proposal": "New proposal",
      "proposals_sent_one": "{{count}} proposal submitted",
      "proposals_sent_other": "{{count}} proposals submitted",
      "review": "Review",
      "send": "Submit proposal",
      "sent": "Proposal submitted.",
      "sent_at": "Values in US dollars (USD). Submitted on {{date}} — editable until the quotation closes.",
      "subtotal": "subtotal",
      "table_summary": "Summary",
      "total_hint": "sum of the three blocks, calculated automatically",
      "updated": "Proposal updated.",
      "values_hint": "Values in US dollars (USD). Editable until the quotation closes.",
      "withdraw": "Withdraw proposal {{sequence}}",
      "withdraw_confirm_description": "The proposal will no longer count for this quotation and cannot be resubmitted.",
      "withdraw_confirm_title": "Withdraw proposal {{sequence}}?",
      "withdrawn": "Proposal withdrawn.",
      "your_proposal": "Your proposal"
    },
    "canceled": {
      "description": "This quotation was canceled by the shipper on <strong style=\"white-space:nowrap\">{{date}}</strong>. The proposal can no longer be sent or edited.",
      "description_BOOKING_DATA": "This booking request was canceled by the shipper on <strong style=\"white-space:nowrap\">{{date}}</strong>. The booking data can no longer be sent.",
      "tip": "Submitted proposals were archived. If in doubt, contact the person responsible for the operation.",
      "tip_BOOKING_DATA": "If in doubt, contact the person responsible for the operation.",
      "title": "Invite canceled",
      "title_BOOKING_DATA": "Booking request canceled",
      "title_BOOKING_QUOTATION": "Quotation canceled"
    },
    "expired": {
      "description": "This quotation's period ended on <strong style=\"white-space:nowrap\">{{date}}</strong>. The proposal can no longer be sent or edited.",
      "tip": "To join a new round, request an updated link from the person responsible for the operation.",
      "title": "Link expired"
    },
    "not_found": {
      "description": "We couldn't find an invite for this link. Check that the address was copied correctly.",
      "title": "Invalid link"
    },
    "otp_form": {
      "code_expiry_hint": "The code expires in 10 minutes",
      "description": "We sent a 6-digit code to {{email}}. Enter the code to open the proposal form.",
      "resend_cooldown": "Resend code in {{time}}",
      "resend_link": "Didn't receive it? Resend code",
      "security_notice": "Single-use link, no Flowls account needed. The link and code are valid only for this invite.",
      "submit": "Access form",
      "title": "Confirm your access",
      "try_again": "Try again"
    }
  },
  "extra_fields": { "boolean": { "empty": "Empty", "false": "No", "true": "Yes" } },
  "file_uploads": {
    "accepted_extensions": "Supported file extensions: {{ extensions }} .",
    "saved_files": "Files saved",
    "upload_file": "Upload File"
  },
  "first_letters": { "days": "d", "hours": "h" },
  "flowls_ai": {
    "beta_warning": "🚧 Please note that this feature is in Beta. Kindly double-check the provided information.",
    "error_message": "There was a problem sending your message. Please try again later.",
    "greetings": "Hello! I am Flowlzito, the Artificial Intelligence from Flowls. How can I assist you?",
    "input_placeholder": "Ask a question...",
    "loading": "I'm thinking",
    "new_conversation": "Start a new conversation"
  },
  "fields": { "duimp": { "advance_delivery": "Advance Delivery" } },
  "foreign_trade": {
    "documents_widgets": {
      "automatic_link_tooltip": "Linked automatically",
      "label": {
        "ANVISA": "ANVISA",
        "BLUE": "Blue Channel",
        "GRAY": "Gray Channel",
        "GREEN": "Green Channel",
        "INMETRO": "INMETRO",
        "MAPA": "MAPA",
        "ORANGE": "Orange Channel",
        "RED": "Red Channel",
        "YELLOW": "Yellow Channel"
      }
    },
    "invoice_widgets": {
      "brazilian": {
        "drawer": {
          "access_key": "Access Key",
          "sections": { "dates": { "emitted_at": "Issue Date", "title": "Dates" } },
          "title": "Invoice (BR) nº",
          "types": { "0": "Inbound", "1": "Outbound" }
        }
      },
      "empty_widget": "There are no invoices registered for this process yet.",
      "products": { "import_products": "Import Products" }
    },
    "palletization": {
      "title": "Palletization",
      "read_only": "Read only",
      "add_pallets": "Add Pallets",
      "empty": "No size informed",
      "size": "Pallet size",
      "quantity": "Qty.",
      "height_cm": "Height (cm)",
      "not_informed": "Don't inform the size",
      "iso_group": "ISO 6780 standard",
      "custom_option": "Custom…",
      "custom": "Custom",
      "total": "Total pallets",
      "empty_description": "Enter how many pallets of each size will be shipped.",
      "size_placeholder": "Select the size…",
      "not_informed_group": "No details",
      "not_informed_option_hint": "total quantity only",
      "not_informed_hint": "Total quantity only — no breakdown by size.",
      "custom_option_hint": "enter L × W",
      "custom_title": "Custom size",
      "length": "Length",
      "width": "Width",
      "errors": {
        "row_invalid": "Enter the size and a quantity greater than zero, or remove the row.",
        "height_invalid": "Height must be greater than zero.",
        "dimension_invalid": "Must be greater than zero"
      }
    },
    "road_transport": {
      "empty_road_transport": "There are no road transports registered for this process yet.",
      "fields": { "DTA": "DTA", "no_DTA": "No DTA" },
      "transport": {
        "container": "Container {{number}}",
        "empty_transport_list": "There are no transports registered for this process yet.",
        "route_required_to_add_trips": "Select a route to enable trips."
      }
    },
    "shared_widgets": {
      "alert_status": {
        "not_found": "Data not found. Please check the entered number.",
        "pending": "Waiting for Data"
      },
      "authorization_status_alert": {
        "forbidden": "The user does not have permission to access the requested resource. Please check the credentials.",
        "not_authorized": "Invalid credentials. Please ensure you have provided the correct security credentials"
      },
      "ce_mercante_alert": "Due to limitations of the source API, it is not possible to identify events that occurred prior to the start of the trace.",
      "cleared_duimp_alert": "Due to limitations of the Siscomex API, it is not yet possible to obtain Customs Clearance Data when a DUIMP (Single Import Declaration) is entered after customs clearance.",
      "insertedAtLabel": "Inserted on {{date}}",
      "updatedAtLabel": "Updated on {{date}}"
    },
    "tracking_widgets": {
      "air": {
        "drawer": {
          "account": "Account",
          "arrival_at": "Actual arrival date",
          "arrival_datetime": "Arrival date/time",
          "arrival_unit_rfb": "RFB arrival unit",
          "basic_info": "Basic information",
          "cargo_items": "Cargo items",
          "collect": "Collect",
          "consignee": "Consignee",
          "currency": "Origin currency",
          "customs_of_arrival": "Arrival customs facility",
          "customs_of_departure": "Departure customs facility",
          "customs_of_destination": "Destination customs facility",
          "departure_at": "Actual departure date",
          "departure_datetime": "Departure date/time",
          "departure_unit_rfb": "RFB departure unit",
          "domestic_departure": "Domestic Departure",
          "estimated_arrival_at": "Estimated arrival date",
          "estimated_departure_at": "Estimated departure date",
          "file_cargo_responsible": "Cargo manifest file responsible",
          "flight_code": "Flight code",
          "inlet_term": "Entry term",
          "international_departure": "International Departure",
          "item_description": "Goods description",
          "item_freight_price": "Freight per cargo item (total)",
          "item_gross_weight": "Gross weight (kg)",
          "item_quantity_of_volumes": "Number of packages",
          "land_arrivals": "Land Arrivals",
          "mawb": "MAWB",
          "prepaid": "Prepaid",
          "receive_cargo": "Cargo presence",
          "ruc_number": "RUC number",
          "shipper": "Shipper",
          "term": "Term",
          "title": "Air cargo",
          "trips": "Trips",
          "uf": "State"
        }
      },
      "ce_mercante": {
        "drawer": {
          "cargo_category": "Cargo Category",
          "consignee": "Consignee",
          "cubage": "Cubage (m³)",
          "freight": "Freight",
          "freight_component_currency": "Currency",
          "freight_component_payment_type": "Payment Type",
          "freight_component_type": "Type",
          "freight_component_value": "Value",
          "freight_components": "Freight Components",
          "general_data": " General Shipment Document Information",
          "modality": "Modality",
          "type": "Shipment Document Type"
        }
      },
      "maritime": {
        "containers": {
          "hide_unlinked": "Don't show Unlinked Containers",
          "link_container": "Link Container to the Process",
          "show_unlinked": "Show Unlinked Containers",
          "unlink_container": "Unlink Container from Process"
        },
        "labels": { "automatic": "Automated Tracking" },
        "international_transport_legs": { "title": "Legs" }
      }
    }
  },
  "form_sections": {
    "audit": { "approve_audit": { "audit_approved": "Audit Approved", "title": "Approve Audit" } },
    "complete_registration": {
      "complete_btn": "Complete Registration",
      "country_input": "Select your Country",
      "description": "This is your first login to the platform, we need to verify some information to complete your registration.",
      "success_completion": "👏🏼 🎉 All set, {{ name }}! Now you can start using Flowls!",
      "terms_and_conditions": "I agree to the Terms of Use and Privacy Policy",
      "title": "Hello, welcome to Flowls!"
    },
    "document_uploads": { "empty_document_list": "There are no documents submitted yet" },
    "export_dates_form": { "title": "Order Dates" },
    "supplier_form": { "title": "Order Dates" },
    "widgets": {
      "drawer": {
        "content": {
          "advance_delivery": "Advance Delivery",
          "basic": "Basic Information",
          "complement": "Complement Information",
          "boarding": "Boarding",
          "cargo": "Cargo",
          "cargo_subfields": {
            "area": "Precinct",
            "arrival_date_time": "Arrival Date/Time",
            "cargo_identification": "Cargo Identification",
            "commercial_invoice": "Linked Commercial Invoice",
            "customs_area": "Customs Facility",
            "dispatch_units": "Dispatch Units",
            "final_destination_unit_of_the_bill_of_lading": "Final Destination Unit of the Bill of Lading",
            "gross_weight": "Gross Weight (kg)",
            "inlet_outlet_unit": "Inlet/Outlet Unit",
            "net_weight": "Net Weight (kg)",
            "origin_country": "Origin Country"
          },
          "clearance": "Customs Clearance",
          "consents": "Licensing Approvals",
          "consents_subfields": {
            "boarding_expiry_date": "Boarding Deadline",
            "consenting_body": "Licensing Approval Authority",
            "consenting_situation": "Licensing Approval Status",
            "dispatch_expiry_date": "Customs Clearance Deadline",
            "license_text": "Approval Text"
          },
          "admin_controls_subfields": {
            "admin_control_body": "Agency",
            "admin_control_situation": "Status of Anuents Inspection",
            "risk_analyses_result": "Risk Analysis Result",
            "situation_licensing": "Licensing Status"
          },
          "customs_subfields": {
            "custom_body": "Agency",
            "custom_situation": "Customs Clearance Status",
            "risk_analyses_result": "Risk Analysis Result"
          },
          "dates": "Dates",
          "delivered": "Delivered",
          "due_events_table": {
            "action": "Event",
            "date": "Date/Hour",
            "extra_info": "Extra Info",
            "responsible": "Responsible"
          },
          "exporter_subfields": { "ruc": "RUC" },
          "general": "General Information",
          "general_subfields": {
            "delivery_status": "Delivery Status",
            "protocol": "Protocol",
            "retification": "Rectification",
            "total_additions": "Total Additions"
          },
          "importer": "Importer",
          "importer_subfields": {
            "address": "Address",
            "identifier": "CNPJ",
            "name": "Name",
            "rfb": "RFB Clearance Unit"
          },
          "national_registration": "CNPJ",
          "packages": "Packages",
          "packages_subfields": {
            "cargo_item": "Cargo Item",
            "danger_class": "Hazard Class",
            "dangerous_goods": "Dangerous Goods",
            "gross_weight": "Gross Weight (kg)",
            "package_type": "Package Type",
            "quantity": "Quantity",
            "type": "Type",
            "use_wooden_packaging": "Use Wooden Packaging",
            "wood_packaging_feature": "Wood Packaging Feature"
          },
          "payments": "Payments",
          "payments_subfields": {
            "fee_value": "Fine Value",
            "payment_date": "Payment Date",
            "total_value": "Total Value",
            "type": "Payment Type"
          },
          "register": "Register",
          "situation": "Status",
          "situation_subfields": {
            "admin_control": "Admin Control",
            "cargo_control": "Cargo Control",
            "customs_control": "Customs Control"
          }
        },
        "forms": { "comment_helper_text": "This comment will be saved when you save the process changes." }
      }
    }
  },
  "global_tracking": {
    "no_content": "Unable to load the map.",
    "title": "Tracking",
    "vessel_overlay": { "knots": "knots" },
    "vessels": {
      "card": { "last_updated_at": "Last Update: {{ date }}" },
      "empty_list": "No results found",
      "filters": {
        "search": "Search for {{ params }}",
        "search_params": {
          "air": "Airplane, process",
          "maritime": "Vessel, Container, Process",
          "road": "Vehicle, Process",
          "train": "Train, Process",
          "warehouse": "Warehouse, Process"
        },
        "show_own_fleet": "Own shipments only"
      }
    }
  },
  "importer_modal": {
    "caption": "Supported Formats: XLSX",
    "description": "Utilize our data import feature to easily upload large amounts of information. Start by downloading the spreadsheet template from the button below. This template will assist you in formatting your data correctly. Then, simply drag and drop your filled-out spreadsheet into the designated area to efficiently import your data.",
    "download_template": "Download template",
    "import_info": "Import {{ title }}",
    "order_products": {
      "product_not_found": "Unable to find the product from line {{ row }} with the code {{ code }}"
    },
    "success": "Import successfully completed. \n Lines successfully imported: {{ importedRows }}",
    "update": "Change file",
    "upload": "Add file"
  },
  "info": { "exporting": "📤 Exporting…" },
  "input_select": {
    "interaction_hint": "Type to search",
    "no_options_select": "No options found",
    "searching": "Searching…",
    "not_found": "Data not found from"
  },
  "insight_indicator": {
    "tooltip_title_one": "{{count}} insight identified",
    "tooltip_title_other": "{{count}} insights identified"
  },
  "insights": {
    "title": "Insights",
    "group_by": {
      "none": "All",
      "category": "By category",
      "analysis": "By analysis",
      "rule": "By rule",
      "entityType": "By entity type",
      "entity": "By entity"
    },
    "filters": {
      "title": "Filters",
      "clear": "Clear",
      "active_label": "Active:",
      "sections": { "category": "Category", "analysis": "Analysis", "rule": "Rule", "entity_type": "Entity type" }
    },
    "toolbar": {
      "heading": "Insights",
      "meta_summary": "{{insightCount}} insights · {{categoryCount}} categories · {{entityCount}} entities",
      "meta_summary_no_entity": "{{insightCount}} insights · {{categoryCount}} categories",
      "search_placeholder": "Search insights...",
      "entity_search_placeholder": "Search entity...",
      "clear_all": "Clear",
      "expand_all": "Expand all",
      "collapse_all": "Collapse all"
    },
    "common": { "all": "All", "expand": "Expand", "collapse": "Collapse" },
    "dashboard": {
      "empty_state": "No insights match these filters.",
      "insights_in_section_one": "{{count}} insight",
      "insights_in_section_other": "{{count}} insights",
      "entity_type_unknown": "Unknown"
    },
    "card": {
      "feedback_great": "Great!",
      "feedback_relevant": "Relevant",
      "feedback_irrelevant": "Not relevant",
      "evidences": "Evidence",
      "evidence_null": "null",
      "date_first_seen": "First seen",
      "date_last_seen": "Last seen"
    },
    "lifecycle": {
      "acknowledged": "Resolved",
      "dismissed": "Not relevant",
      "acknowledge_tooltip": "Resolved — handled and closed",
      "dismiss_tooltip": "Mark as not relevant",
      "dismiss_feedback_title": "Feedback given",
      "dismiss_feedback_none": "Dismissed without a reason"
    },
    "feedback": {
      "title": "Why is it not relevant?",
      "subtitle": "Your feedback trains the model that generates the insights.",
      "comment_placeholder": "What made this insight incorrect? (optional)",
      "submit": "Send feedback",
      "skip": "Dismiss without a reason",
      "error": "Could not save your feedback. Please try again.",
      "reasons": {
        "false_positive": "False positive — not a real problem",
        "irrelevant": "Irrelevant to this process",
        "incorrect_info": "Incorrect or outdated information",
        "duplicate": "Duplicate of another insight"
      }
    },
    "run_audit": {
      "button": "Run audit",
      "cooldown_minutes": "{{minutes}} min",
      "cooldown_tooltip": "Last audit on {{lastRun}}. You can run it again in {{minutes}} min.",
      "cooldown_tooltip_no_last": "You can run it again in {{minutes}} min.",
      "running_title": "Audit in progress",
      "running_subtitle": "Analyzing the process for divergences, inconsistencies and points of attention. Insights will appear here once the run completes.",
      "running_hint": "This can take a few minutes. Feel free to come back later to check the result.",
      "empty_title": "No audit run yet",
      "empty_subtitle": "Start an audit to identify divergences and points of attention in this process.",
      "error_title": "Couldn't load the audit status",
      "error_subtitle": "Something went wrong while loading this process' audit. Please try again.",
      "retry": "Try again"
    }
  },
  "integrations": {
    "api_requests": {
      "filters": {
        "api_keys": "Origin",
        "status_code": { "error": "Errors", "success": "Successes" },
        "title": "Filter by:"
      },
      "modal": { "title": "Request" },
      "operations": { "today": "Today" }
    },
    "docs": {
      "api_key": "API Key",
      "no_content": "There are no available documents.",
      "title": "Docs",
      "download_spec": "Download OpenAPI Spec"
    }
  },
  "json_viewer": {
    "clear_search": "Clear search",
    "collapse_all": "Collapse all",
    "copy_all": "Copy all",
    "expand_all": "Expand all",
    "items": "items",
    "keys": "keys"
  },
  "kanban": { "phase_column": { "order_by": "Order by" } },
  "language_switcher": { "en-US": "English-US", "es-ES": "Spanish", "pt-BR": "Portuguese-BR" },
  "costs": {
    "title": "Costs",
    "tabs": { "aggregated_header": { "processes": "Processes" }, "process": { "title": "Shipments" } },
    "no_content": { "text": "There is no information here." },
    "header": {
      "model_select_label": "Model",
      "reference_date_label": "Reference Date",
      "date_range": { "start_date": "Start", "end_date": "End" }
    }
  },
  "lead_times": {
    "configure_lead_times_modal": {
      "create_lead_time_form": {
        "blocked_stages_section": "To configure the stages of your model, please select which operations this model will contemplate",
        "example": "Example",
        "example_description": "If the reference event for your lead time planning is \"Delivery,\" during the creation of the process you will provide a planned delivery date. All other planned events will be automatically calculated based on this date.",
        "no_dates": "You do not have any dates registered yet.",
        "no_stages": "You do not have any legs registered yet.",
        "reference_event_description": "Set the reference event for the lead time planning:",
        "reference_for_planning": "Lead time planning reference"
      },
      "update_lead_time_model": { "success_message": "Lead Time model updated successfully!" },
      "footer": { "submit_button": "Create Model", "update_button": "Update Model" },
      "lead_time_model": {
        "cannot_delete_model": "It is not possible to delete a Lead Time model while it has Planned Lead Times linked. To do this, manually delete the Planned Lead Times.",
        "deleted_message": "Lead Time model successfully deleted!",
        "planned_lead_time": {
          "deleted_message": "Planned Lead Time successfully deleted!",
          "name": "Planned Lead Time name",
          "no_content": "You do not have any planned lead times registered yet."
        }
      },
      "models_list": { "title": "Models" },
      "no_models": "There are no templates yet.",
      "please_select_a_model": "Please, select a template",
      "title": "Setup Lead Times"
    },
    "header": {
      "no_lead_times_to_export": "There are no Lead Times to export",
      "date_range": { "start_date": "Start", "end_date": "End" }
    },
    "model_select": { "label": "Template" },
    "no_content": { "text": "There is no information here." },
    "stages": { "at_least_one": "Fill in at least one of the fields.", "days": "Days", "hours": "Hours" },
    "tabs": {
      "aggregated_header": {
        "deviation": "Deviation",
        "processes": "Processes",
        "realized_or_estimated": "LT realized/planned"
      },
      "lead_time": { "by_lead_time": "by_lead_time", "title": "Lead Time" },
      "product": { "by_product": "by_produto", "title": "Product" }
    },
    "title": "Lead Times"
  },
  "location_management_modal": {
    "no_place_found": "No place found for the selected actor.",
    "select": { "label": "Actor" },
    "select_local_to_view_map": "Select an address to view the map.",
    "select_place": "Select Place"
  },
  "lpcos": {
    "drawer": {
      "attachments_documents_section": "Documents",
      "attachments_dossiers_section": "Dossiers",
      "attachments_empty": "No attachments linked to this LPCO.",
      "attachments_tab": "Attachments",
      "document_status_discarded": "Discarded",
      "document_status_read": "Read",
      "document_status_unread": "Unread",
      "field_column": "Field",
      "form_completion": {
        "boolean": "Boolean",
        "composite": "Composite",
        "date": "Date",
        "date_and_hour": "Date and time",
        "dynamic_domain": "Dynamic domain",
        "list": "List of values",
        "number": "Number",
        "text": "Text"
      },
      "general_data": "General data",
      "general_tab": "General",
      "generic_attribute": "Attribute",
      "guidance_title": "Guidance",
      "history_automatic": "Automatic",
      "history_changed": "changed",
      "history_request": "Request",
      "import_indicator_direct": "Direct import",
      "import_indicator_on_behalf": "Import on behalf of a third party",
      "import_indicator_on_order": "Import by order",
      "items_list": "Items list",
      "model": "Model",
      "no_dictionary_definition": "Definition not available in the attribute dictionary.",
      "not_catalogued": "Not catalogued",
      "possible_values_title_one": "Possible value ({{count}})",
      "possible_values_title_other": "Possible values ({{count}})",
      "required_attribute": "required",
      "show_less": "Show less",
      "show_more": "Show more",
      "value_column": "Value",
      "validity_expired_one": "Expired {{count}} day ago",
      "validity_expired_other": "Expired {{count}} days ago",
      "validity_remaining_one": "Valid for {{count}} more day",
      "validity_remaining_other": "Valid for {{count}} more days",
      "validity_title": "Validity"
    },
    "list": {
      "columns": {
        "agency": "Agency",
        "identification": "Identification",
        "insights": "Insights",
        "linked_declarations": "DUIMPs / DUEs",
        "model": "Model",
        "model_agency": "Model / Agency",
        "status": "Status",
        "validity": "Validity"
      },
      "expiry": {
        "days_one": "{{count}} day",
        "days_other": "{{count}} days",
        "expired": "Expired",
        "months_days": "{{months}}m {{days}}d",
        "months_one": "{{count}} month",
        "months_other": "{{count}} months",
        "suffix": "until expiry",
        "today": "Today",
        "years_months": "{{years}}y {{months}}m",
        "years_one": "{{count}} year",
        "years_other": "{{count}} years"
      },
      "filters": { "insights": "Insights", "no_agency_options": "No agencies available on this page" },
      "not_linked": "Not linked",
      "page_title": "LPCOs",
      "result_count_one": "{{count}} result",
      "result_count_other": "{{count}} results",
      "search_placeholder": "Search LPCO number…",
      "title": "LPCO",
      "view_action": "View LPCO"
    }
  },
  "maritime_transport": {
    "mercante": {
      "datagrid": { "end_date": "End Date (ETB)", "start_date": "Start Date (ETB)", "vessel_country": "Vessel Flag" },
      "title": "Mercante Schedules"
    }
  },
  "modals": {
    "batch_update": {
      "automatic_tracking_alert": "The processes <strong>{{ referenceCodes }}</strong> have Automatic tracking enabled. Upon saving, it will be disabled for these processes.",
      "btn_label": "Update",
      "components": {
        "field_select": "Fields",
        "preview_table": { "empty": "No data changed", "title": "Changed fields" },
        "process_alert": "Please select at least one process",
        "process_list_title": "Processes to be updated"
      },
      "title": "Batch update",
      "update_success": "Processes updated successfully"
    },
    "create_automation": { "title": "Create Automation" },
    "create_order": { "create_btn": "Create Order", "success": "Order created successfully!", "title": "New Order" },
    "create_process": {
      "add_to_process": "Add to Process",
      "alert_add_to_process_more": "You added {{ productsAdded }} products to process",
      "alert_add_to_process_one": "You added 1 product to process",
      "create_btn": "Create Process",
      "error": {
        "missing_products_to_orders": "To create the process, add products from all purchase orders.",
        "order_ids": "Choose at least one order",
        "product_items": "Add at least one product to this Process",
        "reference_code": "Enter the Process Number",
        "required_lead_time_datetime_reference": "Choose a reference date for the Planned Lead Time",
        "shipment_modal_type": "Select a transportation mode"
      },
      "link_lead_time": { "form": { "datetime_reference": "[{{referenceEvent}}] planned" } },
      "link_orders": { "label": "Order", "placeholder": "Select Orders", "searching": "Searching Orders…" },
      "orders": { "title": "Orders" },
      "process_content": { "title": "Product List" },
      "shipment_type": { "title": "Transportation Mode" },
      "submit_process": "Create Process",
      "success": "Process created successfully!",
      "table": { "order_total": "Order Total", "this_process": "In this Process" },
      "title": "New Process"
    },
    "location_creation": {
      "address_search": "Search address",
      "new_address": "New Address",
      "search_for_a_address_to_continue": "Search for an address to continue",
      "success": "Place registered successfully!",
      "title": "Create New Address",
      "waiting_address": "Waiting Address…"
    },
    "location_deletion": {
      "cannot_remove_address": "Addresses assigned to a route cannot be removed",
      "description": "Are you sure you want to remove this address? This action is irreversible.",
      "success": "Address successfully removed!",
      "title": "Remove Address"
    },
    "location_edit": { "success": "Address successfully updated!", "title": "Edit Address" },
    "order_creations": {
      "create": "Create",
      "title": "Transport Order",
      "toast_messages": {
        "error_especific_handler": "Select a {{handler}}",
        "error_reference_code": "Enter the reference",
        "error_road_transport_order": "Fill in the order details",
        "error_road_transport_order_type": "Fill in the order type",
        "route": "Select a Route",
        "success": "✅  Order successfully created!"
      }
    },
    "update_order": {
      "reset_changes_btn": "Discard Changes",
      "success": "Order successfully updated!",
      "update_btn": "Update Order"
    },
    "confirm_cost_close": {
      "title": "Close Cost",
      "description_with_planned": "Are you sure you want to close this cost? This action will pause planned cost propagation and prevent further updates to realized costs.",
      "description": "Are you sure you want to close this cost? This action will prevent further updates to realized costs."
    },
    "confirm_update_process_cost_model_version": {
      "title": "Change Cost Model Version",
      "description": "Are you sure you want to change this cost model version? This action will remove realized costs from the current version."
    },
    "confirm_cost_reopen": { "title": "Reopen Cost", "description": "Are you sure you want to reopen this cost?" }
  },
  "not_authorized": {
    "description": "Sorry, you do not have access to this feature.",
    "go_to_home": "Back Home",
    "title": "Unauthorized"
  },
  "operation_trash": {
    "modal": {
      "description": "By clicking Confirm, the retrieved item will be available in the Operation.",
      "title": "Retrieve {{entity}} {{reference_code}}?"
    },
    "tabs": { "orders": "Orders", "processes": "Processes" },
    "title": "Trash"
  },
  "container_components": { "create_form": { "sections": { "washing": "Container Washing" } } },
  "operations": {
    "export_excel": "Export Spreadsheet",
    "exporting_data_sheet": "Exporting spreadsheet…",
    "exporting_excel": "Exporting…",
    "exporting_excel_success": "Spreadsheet successfully exported!",
    "exporting_excel_error": "Error exporting spreadsheet. Please try again later.",
    "new_process": "New Process",
    "phases": { "FINISHED": "Finished" },
    "quick_filters": {
      "filter_options_column": {
        "empty_filtered_results_text": "No Results Found",
        "search_input_label": "Filter",
        "is_empty": "Is empty",
        "is_not_empty": "Not empty"
      },
      "title": "Quick Filters"
    },
    "tabs": { "kanban": "Kanban", "lead_times": "Lead Times", "table": "Table", "costs": "Costs" },
    "title": "Operations"
  },
  "operations_table": { "title": "Table" },
  "order_components": {
    "product_list_form": {
      "fields": { "sku": "SKU" },
      "sections": {
        "adjusted_lead_time": "Lead Time - Adjusted",
        "administrative_treatment": "Administrative Treatment",
        "customs": "Customs",
        "default_lead_time": "Lead Time - Default",
        "delivery": "Delivery",
        "item_status": "Item Status",
        "invoice": "Invoice",
        "note": "Notes",
        "order": "Order",
        "planning": "Planning",
        "product": "Product",
        "shipment": "Shipment",
        "stock": "Stock",
        "supplier": "Supplier",
        "tax_treatment": "Tax Treatment"
      }
    }
  },
  "order_modal": {
    "actions_menu": {
      "cancel_order_with_processes": "Do you want to cancel the order and all associated processes?",
      "cancel_order": "Cancel Order",
      "delete_order_with_processes": "Do you want to delete the order and all associated processes?",
      "delete_order": "Delete Order",
      "disallow_cancel_order": "It is not possible to cancel this order as long as any of its processes is linked to other orders. To proceed, manually cancel/delete the processes.",
      "disallow_delete_order": "It is not possible to delete this order as long as any of its processes is linked to other orders. To proceed, manually cancel/delete the processes.",
      "disallow_finish_order": "This request cannot be finalized while any of its processes are still open. To do so, finalize the processes manually.",
      "enter_the_reference_code": "Enter the Order Reference Code to continue.",
      "finish_order": "Finish Order",
      "reference_code": "Reference Code",
      "unfinish_order": "Reopen Order"
    },
    "cancel": "Order successfully canceled!",
    "delete": "Order successfully deleted!",
    "extra_subform": "Extra Fields",
    "finish_order_confirmation_description": "Would you like to finish the Order?",
    "unfinish_order_confirmation_description": "Would you like to reopen the Order?",
    "finish_order_confirmation_title": "Order Finalization",
    "unfinish_order_confirmation_title": "Order Reopening",
    "finish_order_error": "Order could not be finalized.",
    "finish_order_success": "Order successfully finished!",
    "unfinish_order_success": "Order successfully reopened!",
    "save": "Save Changes",
    "success": "Changes saved successfully!",
    "tabs": { "order_data": "Order Information", "pdf_documents": "PDF Documents", "processes": "Processes" }
  },
  "pdf_documents": { "no_content": "There are no PDF documents available for this operation." },
  "process": {
    "checkpoints_processes": {
      "processes": "Processes: {{total}} | Ongoing: {{opened}} | Closed: {{finished}}",
      "waiting": "Pending Processes"
    }
  },
  "process_components": {
    "booking_quotation": {
      "title": "Booking quotation",
      "not_started": "Not started",
      "freight_agents": "Freight agents",
      "no_agents": "No freight agent in the notification group of the quotation page",
      "documents": "Process documents to send",
      "search_document": "Search process document",
      "documents_selected": "{{selected}} of {{total}} selected",
      "closes_at": "Closing date-time ({{timezone}})",
      "documents_hint": "Available on each agent's link",
      "period_preview": "Expected duration",
      "send": "Send quotation",
      "sent": "Quotation sent to the agents",
      "save_before_send": "Save the changes before sending the quotation",
      "view_draft": "View draft",
      "review": "Review",
      "preview_title": "Quotation draft",
      "confirm_send_title": "Confirm quotation submission",
      "opened_at": "Opened on {{date}} ({{timezone}})",
      "cancellation_reason": "Cancellation reason: {{reason}}",
      "cancel": "Cancel quotation",
      "cancel_confirm_description": "Quotation {{reference}} will be closed without a winner. Received proposals are archived and the links stop accepting submissions.",
      "cancel_reason_label": "Reason (optional)",
      "cancel_reason_placeholder": "E.g.: shipment postponed by the client",
      "cancel_notified": "Will be notified by e-mail",
      "canceled": "Quotation canceled",
      "sealed": {
        "title": "Proposals sealed until closing",
        "description": "No value is visible before the end of the period. All proposals open at the same time."
      },
      "closes_at_short": "closes {{date}} ({{timezone}})",
      "responded_count": "<strong>{{responded}}</strong> of {{invited}} responded",
      "values_hidden": "values hidden",
      "last_updated_at": "Updated {{date}}",
      "decline_reason": "Reason: {{reason}}",
      "reopen": "Reopen quotation",
      "closed_at": "Closed on {{date}} ({{timezone}}) · {{responded}} of {{invited}} responded",
      "compare": {
        "button": "Compare proposals",
        "title": "Compare proposals",
        "responded": "{{responded}} of {{invited}} responded",
        "proposals_count_one": "{{count}} proposal",
        "proposals_count_other": "{{count}} proposals",
        "closed_at": "closed {{date}}",
        "export": "Export Excel",
        "export_error": "Could not export the comparison",
        "sections": {
          "conditions": "Conditions",
          "origin": "Origin",
          "international": "International",
          "destination": "Destination"
        },
        "labels": { "transit_time": "Transit time", "representativeness": "% representativeness" },
        "transit_days_one": "{{count}} day",
        "transit_days_other": "{{count}} days",
        "proposal_label": "Proposal {{index}}",
        "sent_at": "Sent {{date}}",
        "edited_at": "Edited {{date}}",
        "lowest_cost": "Lowest cost",
        "representativeness_tooltip": "Percentage of the proposal's total cost over the Invoices final value — base of {{value}}.",
        "attachments": "Attachments",
        "attachments_count_one": "{{count}} attachment",
        "attachments_count_other": "{{count}} attachments",
        "name_winner": "Name winner",
        "file_name": "proposals_comparison",
        "footer_hint": "Click an agent to open the proposal details and attachments.",
        "close": "Close",
        "empty": "No proposals submitted",
        "proposal": "Proposal",
        "total": "Total",
        "view_details": "View details",
        "list_footer": "The full comparison and each proposal's attachments open in a dedicated screen."
      },
      "proposal_drawer": {
        "proposal": "Proposal · {{number}}",
        "sent_at": "Sent at",
        "edited_at": "Edited at",
        "summary": "Summary",
        "goods_value_percent": "% of goods value",
        "route": "Loading → Discharge",
        "values": "Values",
        "total": "Proposal total",
        "total_hint": "Sum of the six factors provided by the agent"
      },
      "snapshot_changes": {
        "title": "Process data changed after sending",
        "description": "The invited agents quoted with the previous values and may need to review their proposals."
      },
      "name_winner": {
        "title": "Name winner",
        "description": "Name <strong>{{agent}}</strong> as the winner of quotation {{reference}}? This action cannot be undone.",
        "total": "Proposal total",
        "sealine_route": "Sealine · Ports",
        "collection_notes": "Pickup notes (optional)",
        "collection_notes_placeholder": "E.g.: pickup location, hours and contact",
        "on_confirm": "On confirm",
        "confirmation_email": "<strong>Confirmation</strong> e-mail sent to the winner",
        "thanks_email": "<strong>Thank-you</strong> e-mail sent to the other participants",
        "confirm": "Name winner",
        "success": "Winner named"
      },
      "winner": {
        "banner": "{{agent}} was named the winner",
        "badge": "Winning proposal",
        "route": "Loading → Discharge",
        "awaiting_booking": "Awaiting booking data",
        "link_sent_at": "Link sent on {{date}}",
        "resend_link": "Resend booking link",
        "resend_success": "Booking link resent",
        "automations": "Triggered automations",
        "confirmation_sent": "<strong>Confirmation</strong> e-mail sent to {{agents}}",
        "thanks_sent": "<strong>Thank-you</strong> e-mail sent to {{agents}}"
      }
    },
    "demurrage": {
      "sections": { "container": "Container", "demurrage": "Demurrage", "payments": "Pagamentos", "status": "Status" }
    },
    "deadlines": {
      "title": "Vessel Schedules",
      "subtitle": "Export",
      "dates": {
        "draft": { "title": "Deadline DRAFT", "subtitle": "Shipping Instructions" },
        "vgm": { "title": "Deadline VGM", "subtitle": "Verified Gross Mass" },
        "gate": { "title": "GATE", "subtitle": "Gate Opening" },
        "cargo": { "title": "Deadline CARGO", "subtitle": "Cargo" }
      },
      "reference_popper": {
        "title": "Change Reference",
        "description": "Note: The auto mode automatically selects the most restrictive date among the available ones.",
        "select": "Select"
      },
      "table": { "last_search": "Last search" },
      "alert_status": {
        "not_found": "Data not found for this Vessel and Voyage Number",
        "pending": "Waiting for Data",
        "invalid": "Invalid Data",
        "sealine_not_supported": "We do not yet have an integration with this Sealine for Vessel Scheduling"
      }
    }
  },
  "process_modal": {
    "actions_menu": {
      "cancel_process": "Cancel Process",
      "delete_process": "Delete Process",
      "enter_the_reference_code": "Enter the Process Reference Code to proceed.",
      "finish_process": "Finish Process",
      "unfinish_process": "Reopen Process"
    },
    "cancel": "Process successfully canceled!",
    "cargo_information": { "fields": { "cargo_type": "Cargo Type" }, "title": "Cargo Information" },
    "insights": { "tab": "Insights" },
    "costs": {
      "tab": "Costs",
      "deviation": "Deviation",
      "planned": "Planned",
      "realized": "Realized",
      "average": "Average",
      "per_reference": {
        "informations": { "expenses": "Expenses" },
        "titles": {
          "BRAZILIAN_INVOICE_VALUE": "Brazilian Invoice Value",
          "CALCULATED_CUBAGE_CUBIC_METERS": "Calculated Cubage",
          "CALCULATED_GROSS_WEIGHT_KG": "Calculated Gross Weight",
          "GROSS_WEIGHT_KG": "Gross Weight",
          "QUANTITY": "Quantity"
        }
      },
      "tabs": { "product": "Product", "shipment": "Shipment", "per_reference": "Unit Calculations" },
      "update": { "success": "Cost successfully saved" },
      "toolbar": {
        "export": "Export",
        "export_error": "Error exporting costs. Please try again later.",
        "export_loading": "Exporting...",
        "expand": "Expand",
        "filter_items": "Filter items",
        "collapse": "Collapse",
        "close_cost": "Close Cost",
        "reopen_cost": "Reopen Cost",
        "export_columns": {
          "cost": "Cost",
          "deviation": "Deviation",
          "group": "Group",
          "planned_cost": "Planned",
          "precification_model": "Precification Model",
          "product": "Product",
          "realized": "Realized",
          "reference_product_prorated": "Prorated Reference",
          "reference_value": "Reference Value",
          "reference": "Reference",
          "sub_group": "Subgroup",
          "total_deviation": "Total Deviation",
          "total_planned_cost": "Total Planned",
          "total_realized": "Total Realized",
          "uniqueness": "Uniqueness",
          "unitary_deviation": "Unitary Deviation",
          "unitary_planned_cost": "Unitary Planned",
          "unitary_realized": "Unitary Realized"
        }
      },
      "totals": { "title": "TOTAL", "reference": "Shipment" }
    },
    "delete": "Process successfully deleted!",
    "finish_process_confirmation_description": "Would you like to finish the process?",
    "unfinish_process_confirmation_description": "Would you like to reopen the process?",
    "finish_process_confirmation_title": "Process Finalization",
    "unfinish_process_confirmation_title": "Process Reopening",
    "finish_process_error": "Process could not be finished.",
    "unfinish_process_error": "Process could not be reopened.",
    "finish_process_success": "Process successfully finished!",
    "unfinish_process_success": "Process successfully reopened!",
    "history": {
      "changes": { "types": { "insert": "Creation", "delete": "Deletion", "update": "Update" } },
      "no_content_message": "There are no changes in this Process",
      "title": "Change History"
    },
    "lead_time": {
      "conclusion_date": "Conclusion Date",
      "no_content": "There are no linked Lead Times",
      "error_content": "Error calculating expected lead times, please check the inserted dates.",
      "preview_conclusion_date": "Predicted finish date",
      "status": { "ADVANCED": "Advance by {{time}}", "LATE": "Delayed {{time}}", "ON_TIME": "On Time" },
      "timeline": {
        "titles": { "deviance": "Deviation", "planned": "Planned", "realized": "Realized/Predicted" },
        "today": "Today"
      },
      "errors": {
        "realized": "Realized",
        "estimated": "Estimated",
        "planned": "Planned",
        "dates": "Dates",
        "lead_time": "Lead Time"
      },
      "update": { "success": "Lead Time successfully saved" }
    },
    "process_not_found": "Process Not Found.",
    "process_unauthorized": "You do not have permission to access this process.",
    "reset_changes_btn": "Discard Changes",
    "reset_changes_confirmation_description": "Unsaved changes will be discarded. Do you want to proceed?",
    "reset_changes_confirmation_title": "Discard Changes",
    "restored": "Item successfully restored!",
    "save": "Save Changes",
    "success": "Changes saved successfully!"
  },
  "products": {
    "edit_products": {
      "page_title": "Edit Product",
      "save": "Save",
      "success": "Product successfully saved",
      "title": "Edit Product"
    },
    "product_drawer": { "title": "Product Details" },
    "products_form": {
      "package_levels": "Package Levels",
      "package": "Package and Logistic",
      "primary_package": "Primary Package",
      "product_characteristics": "Product Characteristics",
      "product_data": "Product Information",
      "success": "Product added successfully",
      "popover_info": {
        "title": "Informações",
        "popover_info": {
          "title": "Information",
          "package_data": {
            "conclusion": "These levels help better represent the product in the logistics chain and facilitate planning, transport, and cost calculations.",
            "example_title": "You can further detail with optional packaging levels:",
            "info": "The Primary Packaging is the base registration unit, used as a reference for the product quantity when creating processes.",
            "examples": {
              "containerization": "Containerization (e.g., pallets in a container)",
              "content": "Content (e.g., bottle)",
              "multiple": "Multiple (e.g., boxes inside a larger box)",
              "palletization": "Palletization (e.g., boxes on a pallet)"
            }
          }
        }
      }
    },
    "products_list": {
      "add_new": "Add Product",
      "archive_confirm_description": "This product will be archived and removed from the active list. Do you want to proceed?",
      "archive_confirm_title": "Archive product?",
      "page_title": "Products",
      "product_archived": "Product archived successfully!",
      "title": "Products"
    },
    "products_new": { "page_title": "Add Product", "title": "Add Product" }
  },
  "report_columns": {
    "shared": {
      "automatic": "Automatic",
      "deviation_days": "Deviation",
      "manual": "Manual",
      "operation_name": "Operation",
      "reference_code": "Reference Code",
      "tracking_mode": "Tracking Mode",
      "tracking_status": "Tracking Status"
    },
    "shipment_containers": "Shipment Containers",
    "realized_at": "Realized"
  },
  "reports": {
    "add_new": "Create Report",
    "delete": {
      "success_message": "Report successfully deleted",
      "title": "Are you sure you want to delete the report {{ reportName }}?"
    },
    "edit_report_modal": { "success": "Report successfully updated", "title": "Edit Report" },
    "new_report_modal": { "success": "Report successfully created", "title": "Create new report" },
    "refresh": "Refresh",
    "report_changes": {
      "save": "Save Report",
      "success": "Report successfully saved",
      "title": "This report has unsaved changes.",
      "revert": "Revert changes"
    },
    "report_modal": { "name_field": "Report Name" },
    "select_report": "Report",
    "table": { "no_content": "No report to display" },
    "export": {
      "success_message": "The report is being processed in the background. You can navigate to other pages while this happens"
    },
    "duplicate_report_modal": {
      "title": "Duplicate report",
      "success": "Report duplicated successfully",
      "unsaved_changes_tooltip": "There are unsaved changes"
    }
  },
  "routes": {
    "edit_route": { "page_title": "Edit Route" },
    "new_route": {
      "actions": {
        "add_event": "Add Event",
        "add_local": "Add Place",
        "add_route": "Add Route",
        "edit_local": "Edit Place",
        "remove_event": "Remove Event",
        "remove_local": "Remove Place"
      },
      "page_title": "New Route"
    },
    "route_form": {
      "add_local": "Add places to events to view the map.",
      "road_transport": "Road Transport",
      "route_data": "Route Information",
      "successfully_created": "Route created successfully! ",
      "successfully_updated": "{{routeName}} successfully updated!"
    },
    "routes_list": {
      "page_title": "Routes",
      "route_deleted_successfully": "Route successfully deleted!",
      "table": { "active": "ACTIVE", "inactive": "INACTIVE", "status": "Status" }
    }
  },
  "search": { "location_placeholder": "Search Address", "placeholder": "Search…" },
  "select_workspace": { "loading": "Loading workspaces...", "title": "Select your workspace", "search": "Search" },
  "settings": {
    "credentials": {
      "credential_modal": {
        "create_success": "Credential successfully created!",
        "delete_success": "Credential successfully deleted!",
        "edit_credential": "Edit Credential",
        "expired_at": "Expired on:",
        "expires_at": "Valid until:",
        "new_credential": "New Credential",
        "password": "Password",
        "update_file": "Update File",
        "update_success": "Credential updated successfully!",
        "username": "Username"
      },
      "credential_types": "Credential Types",
      "no_credentials": "There are no credentials to show.",
      "search": "Search",
      "title": "Credentials"
    },
    "general_data": {
      "card_size_description": "Enabling this option makes the cards smaller, reducing vertical screen space usage.",
      "date_format": "Date Format",
      "language_and_regional_settings": "Language & Regional Settings",
      "success": "General Data updated successfully!",
      "time_format": "Time Format"
    },
    "notification_groups": {
      "add_recipient_success": "Recipient added successfully!",
      "create_success": "Notification group created successfully!",
      "delete_recipient_success": "Recipient deleted successfully!",
      "update_recipient_success": "Recipient updated successfully!",
      "recipient_modal": {
        "add_recipient": "Add recipient",
        "edit_recipient": "Edit recipient",
        "title": "Manage recipients",
        "language": "Language",
        "manage_recipients": "Manage recipients",
        "no_recipients": "No recipients for this role",
        "no_roles": "No roles configured for this group",
        "partnership": "Partner"
      },
      "delete_success": "Notification group deleted successfully!",
      "form": {
        "create_button": "Create group",
        "create_title": "New notification group",
        "edit_button": "Save changes",
        "edit_title": "Edit notification group"
      },
      "new_group": "New Group",
      "title": "Notification Groups",
      "update_success": "Notification group updated successfully!"
    },
    "tabs": {
      "credentials": "Credentials",
      "general_data": "General Data",
      "notification_groups": "Notification Groups",
      "users": "Users",
      "workspace": "Workspace"
    },
    "title": "Settings",
    "users": {
      "create_success": "User created successfully!",
      "delete_success": "User deleted successfully!",
      "edit": { "button_confirm": "Edit User", "title": "Edit User" },
      "export": { "filename": "UsersList" },
      "new": { "button_confirm": "Create User", "title": "New User" },
      "table": { "last_login_without_data": "No prior access" },
      "update_success": "User updated successfully!",
      "search_field_error": "Search must contain {{minLength}} or more characters"
    },
    "workspace": {
      "document_type_label": { "default": "Official Document" },
      "image_upload": {
        "caption": "Supported Formats: PNG, JPG, and SVG",
        "update": "Edit Logo",
        "upload": "Add Logo"
      },
      "success": "Workspace data successfully updated!"
    }
  },
  "sidebar": {
    "actors": "Actors",
    "agents_executions": "Executions",
    "agents": "Agents",
    "docs": "API Documentation",
    "documents": "Documents",
    "drivers": "Drivers",
    "insights": "Insights",
    "integration_logs": "Integration Logs",
    "integrations": "Integrations",
    "lpcos": "LPCOs",
    "maritime_transport": "Maritime Transport",
    "mercante": "Mercante",
    "new_agent": "New Workflow",
    "operations": "Operations",
    "port_terminals": "Port Terminals",
    "products": "Products",
    "road_transport": "Road Transport",
    "routes": "Routes",
    "settings": "Settings",
    "sign_out": "Sign out",
    "support": "Support",
    "switch_workspace": "Switch workspace",
    "tracking": "Tracking",
    "trailers": "Trailers",
    "vehicles": "Vehicles"
  },
  "siscomex_product": {
    "drawer": {
      "attributes_section": "Attributes",
      "created_at": "Created at",
      "not_synced": "Product not yet synced with the Siscomex Catalog.",
      "summary_section": "Summary",
      "title": "Siscomex · Product Catalog"
    }
  },
  "siscomex_sync": {
    "rows": {
      "connector": "Connector",
      "entity": "Entity",
      "in_progress": "in progress",
      "inserted_at": "Inserted at",
      "last_sync": "Last sync"
    },
    "rate_limited": "Sync can only be forced once every 60 seconds. Please try again shortly.",
    "sync_now": "Sync now",
    "syncing_title": "Syncing"
  },
  "subscription_update_snackbar": {
    "order": {
      "description": "Do you want to update the order with the latest changes? Your changes might be overwritten by the update.",
      "title": "There have been changes in the order",
      "update_button": "Update Order",
      "updated_message": "There were changes in the order, and the order was updated automatically."
    },
    "process": {
      "description": "Do you want to update the process with the latest changes? Your changes might be overwritten by the update.",
      "title": "There have been changes in the process",
      "update_button": "Update Process",
      "updated_message": "There were changes in the process, and the process was updated automatically."
    }
  },
  "trailers": {
    "edit_trailer": { "page_title": "Edit Trailer", "success": "Trailer updated successfully" },
    "new_trailer": {
      "form_fields": { "without_tracker": "No tracker installed" },
      "page_title": "New Trailer",
      "success": "Trailer created successfully"
    },
    "trailers_list": {
      "add_new_trailer": "Add Trailer",
      "page_title": "Trailers",
      "table": { "tracking": "Tracker" },
      "trailer_deleted": "Trailer deleted successfully"
    }
  },
  "trip": {
    "containers": "Container Transport",
    "tracking": {
      "client_arrival_at": "Arrival at Customer",
      "client_departure_at": "Departure from Customer",
      "end_at": "Journey End",
      "invoice_exchange_end_at": "Departure from Invoice Swap",
      "invoice_exchange_start_at": "Arrival to Invoice Swap",
      "start_at": "Trip Start",
      "title": "Tracking"
    }
  },
  "unsaved_dialog": { "description": "Are you sure you want to discard these changes?", "title": "Unsaved Changes" },
  "upload_file_order": {
    "addNew": "File Upload",
    "btnSalvar": "Salve",
    "buttonUpload": "Add new file",
    "selectFiles": "Select file type",
    "success": "File successfully deleted"
  },
  "vehicles": {
    "edit_vehicle": { "page_title": "Edit Vehicle", "success": "Vehicle updated successfully" },
    "new_vehicle": {
      "form_fields": { "without_tracker": "No tracker available" },
      "page_title": "Add Vehicle",
      "success": "Vehicle successfully added"
    },
    "vehicles_list": {
      "add_new_vehicle": "Add Vehicle",
      "change_vehicle": "Change Vehicle",
      "page_title": "Vehicles",
      "table": { "tracking": "Tracker" },
      "vehicle_deleted": "Vehicle successfully deleted!"
    }
  },
  "vessels": { "country": "Country of Vessel" },
  "warnings": {
    "after_deleting_temporary": "Once deleted, you can recover it by clicking discard changes before saving. Do you want to proceed?",
    "after_deleting_this_information": "Once this information is deleted, it cannot be recovered. Do you want to proceed?",
    "are_you_sure": "Are you sure?",
    "empty_general_list_message": "There is no information here yet.",
    "not_informed": "-",
    "process_empty_data_list_message": "This process does not have data yet.",
    "there_is_already_a_record_registered_with_this_number": "A record with this number already exists.",
    "this_action_can_not_be_undone": "This action is irreversible. Do you wish to proceed?",
    "this_item_can_not_be_deleted": "It is not possible to delete this item!",
    "this_will_be_automatically_fulfilled": "This field will be automatically filled when the order is created.",
    "to_delete_item": "Delete {{text}} ?",
    "without_data_to_export": "There are no data to export"
  },
  "yup": {
    "at_least_one": "This field must have at least 1 item.",
    "cannot_be_equal_to": "This field must be different from the field {{otherField}}",
    "mixed_invalid_field": "Invalid field.",
    "mixed_required_field": "This field is required",
    "number_max": "This field must be less than {{max}}.",
    "number_min": "This field must be greater than {{min}}.",
    "required_field": "The field {{ fieldName }} is required.",
    "string_email": "This field must be a valid email.",
    "string_https_url": "The URL must use the HTTPS protocol.",
    "string_max": "This field must have fewer than ${max} characters.",
    "string_min": "This field must have more than ${min} characters."
  }
}
